import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { User } from '@/api/DTO/auth.interface';

export interface IAuth {
	accessToken: string | null;
}

type AuthState = {
	accessToken: string | null;
	resetSessionId: string | null;
	resetPasswordToken: string | null;
	otpToken: string | null;
	otpEmail: string | null;
	myInfo: User;
	justLoggedIn: boolean;
	loggedOut: boolean;
};

const authSlice = createSlice({
	name: 'auth',
	initialState: {
		accessToken: null,
		justLoggedIn: false,
		loggedOut: false,
	} as AuthState,
	reducers: {
		clearJustLoggedIn: (state) => {
			state.justLoggedIn = false;
		},
		setJustLoggedIn: (state) => {
			state.justLoggedIn = true;
		},
		setCredentials: (state, action: PayloadAction<IAuth>) => {
			const { accessToken } = action.payload;
			state.accessToken = accessToken;
			state.loggedOut = false;
		},
		setMyInfo: (state, action: PayloadAction<User>) => {
			state.myInfo = action.payload;
		},
		logOut: (state) => {
			state.accessToken = null;
			state.loggedOut = true;
		},
		setResetSessionId: (state, action: PayloadAction<string>) => {
			state.resetSessionId = action.payload;
		},
		setResetPasswordToken: (state, action: PayloadAction<string>) => {
			state.resetPasswordToken = action.payload;
		},
		clearResetPasswordData: (state) => {
			state.resetSessionId = null;
			state.resetPasswordToken = null;
		},
		setOTPToken: (state, action: PayloadAction<string>) => {
			state.otpToken = action.payload;
		},
		setOTPEmail: (state, action: PayloadAction<string>) => {
			state.otpEmail = action.payload;
		},
	},
});

export const {
	setCredentials,
	clearJustLoggedIn,
	setJustLoggedIn,
	logOut,
	setResetSessionId,
	setResetPasswordToken,
	clearResetPasswordData,
	setOTPToken,
	setOTPEmail,
	setMyInfo,
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentToken = (state: RootState) => state.auth.accessToken;

export const selectLoggedOut = (state: RootState) => state.auth.loggedOut;

export const selectMyInfo = (state: RootState) => state.auth.myInfo;

export const selectResetSessionId = (state: RootState) =>
	state.auth.resetSessionId;

export const selectResetPasswordToken = (state: RootState) =>
	state.auth.resetPasswordToken;

export const selectOTPToken = (state: RootState) => state.auth.otpToken;

export const selectOTPEmail = (state: RootState) => state.auth.otpEmail;
